<div class="input-group">
    <div class="w-100pc font-weight-bold">
        <input id="gridRadios1" name="gridRadios" type="radio" 
        class="margin-right-10 align-middle svg-18 cursor-pointer" [checked]="isSelected"
        (input)="onClick($event)">

        <span *ngIf="!isHideText">{{displayText}}</span>
        
    </div>
</div>